import { MetricType } from '@core/enums/metric.enums'

export const resolvePlayerDetailsNavigationUrl = (
  seasonId: string,
  competitionId: string,
  teamId: string,
  playerId: string
): string => `seasons/${seasonId}/competitions/${competitionId}/teams/${teamId}/players/${playerId}`

export const resolvePlayerMatchNavigationUrl = (matchId: string, teamId: string, playerId: string): string =>
  `matches/${matchId}/teams/${teamId}/players/${playerId}`

export const buildMetricTypeUrl = (metricType: MetricType | string, isAbsolute: boolean = false): string =>
  `${isAbsolute ? '/' : ''}more/metrics/${metricType}`
